import { Component, ViewEncapsulation, Input } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIService } from '@app/cp/shared/services/DQOI.service';
import { v_DispatchGrid2Bus } from '@app/cp/shared/models/v_DispatchGrid2Bus';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';
import { RowClassArgs } from '@progress/kendo-angular-grid';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';

@Component({
    selector: 'dispatch-search-grid',
    templateUrl: './dispatch-search-grid.component.html',
    styleUrls: ['./dispatch-search-grid.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DispatchSearchGridComponent extends BaseGridUIComponent<v_DispatchGrid2Bus, null, DQOIService> {

    constructor(globals: GlobalsService, svc_data: DQOIService) {
        super(globals);
        this.svc_data = svc_data;
    }
    @Input() searchText: string = "";
    public rowSearchHighlight = (context: RowClassArgs) => {
        if (CommonFunctions.hasStringValue(this.searchText)) {
            if (context.dataItem.dispatchNotes.toLowerCase().indexOf(this.searchText.toLowerCase()) >= 0) {
                return { textHigh: true };
            }
        }
        return {};
    }
    public rowSearchHighlight2 = (context: RowClassArgs) => {
        if (CommonFunctions.hasStringValue(this.searchText)) {
            let hReason = context.dataItem.dispatchReason.toLowerCase().indexOf(this.searchText.toLowerCase()) >= 0 ? true : false;
            let hDisp   = context.dataItem.dispatchNumber.toLowerCase().indexOf(this.searchText.toLowerCase()) >= 0 ? true : false;
            let hWO     = context.dataItem.wonumber.toLowerCase().indexOf(this.searchText.toLowerCase()) >= 0 ? true : false;
            return {
                highDisp: hDisp,
                highWO: hWO,
                highReason: hReason
            }
        }
        return {};
    }
}
